import { useWeatherBackdrop } from "@/app/components/weather/WeatherBanner";
import {
  getSkyBackgroundComponent,
  resolveSkyBackground,
} from "@/app/components/weather/backgrounds";

/**
 * Full-viewport weather illustration behind screen content.
 * Renders a sky variant based on the current hour's condition and isDay
 * from {@link useWeatherBackdrop}.
 */
export function WeatherBackground() {
  const { condition, isDay } = useWeatherBackdrop();
  const variant = resolveSkyBackground(condition, isDay);
  const Sky = getSkyBackgroundComponent(variant);

  return (
    <div
      key={variant}
      className="absolute inset-0 overflow-hidden pointer-events-none transition-opacity duration-500"
      aria-hidden="true"
    >
      <Sky />
    </div>
  );
}
